import { VoyagerInput } from '@core/reducers/inputsSlice';
import cn from '@core/utils/classNames';

import styles from './ImportantFactorsFlags.module.css';
import importantFactorsFlagsIcons from './ImportantFactorsFlagsDictionary';

interface ImportantFactorsFlagsProps {
  importantFactors: VoyagerInput;
  asColumn?: boolean;
}

const ImportantFactorsFlags = ({ importantFactors, asColumn = false }: ImportantFactorsFlagsProps) => {
  if (!importantFactors?.options) {
    return null;
  }

  return (
    <div className={cn(styles.flagContent, asColumn && styles.asColumn)}>
      {importantFactors.options.map((flag: { label: string }) => {
        const factorKeys = Object.keys(importantFactorsFlagsIcons);
        const matchedKey = factorKeys.find((key) => key && flag.label.toLowerCase().includes(key.toLowerCase()));
        const icon = matchedKey
          ? importantFactorsFlagsIcons[matchedKey as keyof typeof importantFactorsFlagsIcons]
          : importantFactorsFlagsIcons.default;
        return (
          <div className={styles.flag} key={flag.label}>
            <span className={styles.icon}>{icon}</span>
            {flag.label}
          </div>
        );
      })}
    </div>
  );
};

export default ImportantFactorsFlags;
